export default __webpack_public_path__ + "static/media/sample_1.7b99beb4.png";